module.exports = __webpack_public_path__ + "static/media/info_caution.a434ad1c.png";